import React__default from 'react';
import { DataLayer, CartV2Actions } from '@grandvisionhq/analytics';
import { useMutation } from '@grandvisionhq/graphql';
import { isNil } from '@grandvisionhq/utils';
import { useCartStorage } from './use-cart-storage.js';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import { createProductObject } from '../mappers/analytics/structured-data-mapper.js';
import { REMOVE_CART_LINE_ITEMS } from '../operations/mutations/remove-cart-line-items.js';

const useRemoveFromCart = (lineItem, onSuccess)=>{
    const [{ cartId  }] = useCartStorage();
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: ()=>{
            const dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, [
                lineItem
            ], cartId || '');
            dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
            CartV2Actions.removeLineItemsSdAction([
                createProductObject(lineItem)
            ]);
            onSuccess && onSuccess();
        }
    });
    const removeFromCart = React__default.useCallback(()=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItem.id
                        }, 
                    ]
                }
            },
            refetchQueries: [
                'GetCart'
            ]
        });
    }, [
        lineItem
    ]);
    const { called , loading , error  } = removeCartLineItemsMutation;
    return [
        removeFromCart,
        {
            called,
            loading,
            error
        }
    ];
};

export { useRemoveFromCart };
//# sourceMappingURL=use-remove-from-cart.js.map
